import { TableHeader } from "@/models/TableHeader";

export const staticPageHeaders: TableHeader[] = [
  {
    text: "Name",
    value: "label"
  },
  {
    text: "Page Title",
    value: "meta_title"
  },
  {
    text: "Actions...",
    value: null,
    sortable: false
  }
];
